import { useCallback } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useMagicPenStore } from '@src/stores';

import { generateUniqueId } from '../../helpers';

// Constants imports
import { BASE_OPACITY, DEFAULT_STROKE_WIDTH, EPHEMERAL_PEN_TTL } from '../../magicPen.constants';

import { EMagicPenShape, ICanvasObject, ICreatedBy } from '@src/types';

const usePenTool = (createdBy: ICreatedBy, handleAddObjects: (objects: ICanvasObject[]) => Promise<void>) => {
  const { currentLinePoints, setCurrentLinePoints, brushColor, activeTool } = useMagicPenStore(
    useShallow((state) => ({
      currentLinePoints: state.currentLinePoints,
      setCurrentLinePoints: state.setCurrentLinePoints,
      brushColor: state.brushColor,
      activeTool: state.activeTool,
    }))
  );

  const handlePenMouseUp = useCallback(async () => {
    // Check if we have enough points to create a line (at least 2 points = 4 coordinates)
    if (currentLinePoints.length >= 4) {
      const now = Date.now();
      const isEphemeral = activeTool === 'ephemeralPen';

      const newLine: ICanvasObject = {
        id: generateUniqueId(),
        type: EMagicPenShape.LINE,
        points: [...currentLinePoints],
        stroke: brushColor,
        strokeWidth: DEFAULT_STROKE_WIDTH,
        createdBy,
        opacity: isEphemeral ? BASE_OPACITY : 1,
      };

      if (isEphemeral) {
        newLine.drawEndTime = now;
        newLine.ttlMs = EPHEMERAL_PEN_TTL;
      }

      await handleAddObjects([newLine]);
    }
    setCurrentLinePoints([]);
  }, [currentLinePoints, setCurrentLinePoints, brushColor, createdBy, handleAddObjects, activeTool]);

  return {
    handlePenMouseUp,
  };
};

export default usePenTool;
